import { Box } from '@mui/material';
import { Divider } from 'components/material-ui-styles';
import { StyledDefaultPrimaryButton } from 'styles';
import { useInitializeSubscriptionRealmForm } from 'RealmModule/hooks/useInitializeSubscriptionRealmForm';
import RealmSelector from 'SandboxModule/components/RealmSelector';
import { TenantSelector } from 'TenantModule/components/TenantSelector';

export const InitializeSubscriptionRealmForm: React.FC<Record<string, never>> = () => {
  const {
    onTenantSelectorClick,
    onRealmSelectorClick,
    realmDropdownRef,
    selectedRealm,
    selectedTenant,
    isInitializingSubscriptionRealm,
    onSubmitInitializeSubscriptionRealmForm,
  } = useInitializeSubscriptionRealmForm();

  return (
    <form onSubmit={onSubmitInitializeSubscriptionRealmForm}>
      <h3>Initialize Subscription Realm</h3>
      <Box
        sx={{
          gap: 12,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {selectedTenant ? (
          <TenantSelector onClick={onTenantSelectorClick} tenantId={selectedTenant?.id} />
        ) : (
          <></>
        )}
        <RealmSelector
          onClick={onRealmSelectorClick}
          realmId={selectedRealm?.realm_id || ''}
          ref={realmDropdownRef}
        />
      </Box>
      <Divider sx={{ my: 6 }} />
      <StyledDefaultPrimaryButton type="submit" disabled={isInitializingSubscriptionRealm}>
        Submit
      </StyledDefaultPrimaryButton>
    </form>
  );
};
